module.exports = __webpack_public_path__ + "static/media/Spital.ab5e62b1.webp";